export default "__VITE_ASSET__Dx$H5W21__"